import {Injectable} from "@angular/core";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "./AuthService";
import {MonthlyCalenderPreviewReport, Retailer, Store, StoreDashboard, StoreDirectory} from "../model/Store";
import {apiconfig} from "../app/api.config";

@Injectable()
export class StoreService {

  apiConfig: any = apiconfig;

  constructor(
    private http: HttpClient,
    private authService: AuthService) {
  }

  /**
   * run an API search for Stores
   * @param id
   * @param adminArea
   * @param retailer
   */
  searchStores(id: number, adminArea: string, retailer: string, operation: number, previewPlanningStartDay: number): Promise<Store[]> {
    let h = this.authService.getHttpAuth();

    // build query parameters
    let httpParams = new HttpParams();
    httpParams = httpParams.append("retailerName", retailer);
    httpParams = httpParams.append("administrativeArea", adminArea);
    httpParams = httpParams.append("retailer", "");
    httpParams = httpParams.append("sxp", "");
    if (operation)
      httpParams = httpParams.append("operation", operation + '');
    if (previewPlanningStartDay)
      httpParams = httpParams.append("previewPlanningStartDay", previewPlanningStartDay + '');

    return this.http
      .get(this.apiConfig.API_URL + '/order/search-stores', {
        headers: h,
        params: httpParams
      }).map((res: any) => res.items).toPromise();
  }

  /**
   *
   */
  loadStoreDirectory(): Promise<StoreDirectory> {
    let h = this.authService.getHttpAuth();
    return this.http.get<StoreDirectory>(this.apiConfig.API_URL + '/order/store-directory', {headers: h}).toPromise();
  }

  /**
   *
   */
  loadRetailers(): Promise<Retailer[]> {
    let h = this.authService.getHttpAuth();
    return this.http.get<Retailer[]>(this.apiConfig.API_URL + '/store/retailers', {headers: h}).toPromise();
  }

  /**
   *
   * @param storeId
   * @param year
   * @param month
   * @param operation
   */
  loadStoreDashboard(storeId: number, year: number, month: number, operation: number): Promise<StoreDashboard> {
    let h = this.authService.getHttpAuth();

    // build query parameters
    let httpParams = new HttpParams();
    if (year != null)
      httpParams = httpParams.append("year", year + '');
    if (month != null)
      httpParams = httpParams.append("month", month + '');
    if (operation != null)
      httpParams = httpParams.append("operation", operation + '');

    return this.http.get<StoreDashboard>(this.apiConfig.API_URL + '/order/store/' + storeId + '/dashboard', {
      headers: h,
      params: httpParams
    }).toPromise();
  }


  loadMonthlyCalenderPreviewReport(year: number, month: number): Promise<MonthlyCalenderPreviewReport> {
    let h = this.authService.getHttpAuth();

    // build query parameters
    let httpParams = new HttpParams();
    if (year != null)
      httpParams = httpParams.append("year", year + '');
    if (month != null)
      httpParams = httpParams.append("month", month + '');

    return this.http.get<MonthlyCalenderPreviewReport>(this.apiConfig.API_URL + '/order/monthly-calendar-activities-overview', {
      headers: h,
      params: httpParams
    }).toPromise();
  }

}



// WEBPACK FOOTER //
// ./src/services/StoreService.ts